import { cashBookingRefusalKey } from './cashBookingRefusal';

/**
 * The message to show for a failed API response. The backend answers a refusal with
 * `{ error: '...' }` (`sendServiceErrorResponse`) and a few routes with `{ message: '...' }`;
 * either is the reason the operator needs to see, so the generic status text is only the
 * fallback for a body that carries neither. A refused cash booking also carries a `code`, whose
 * translation (`translate`) replaces the backend's English text.
 */
export function apiErrorMessage(
    body: unknown,
    status: number,
    translate?: (key: string) => string,
): string {
    const refusalKey = cashBookingRefusalKey(body);
    if (refusalKey && translate) {
        return translate(refusalKey);
    }
    const record = typeof body === 'object' && body !== null ? (body as Record<string, unknown>) : {};
    if (typeof record.message === 'string' && record.message) {
        return record.message;
    }
    if (typeof record.error === 'string' && record.error) {
        return record.error;
    }
    return `HTTP error! status: ${status}`;
}
